import { helper } from '@/plugins/helper.client';
class Transform {
  constructor({ response, data, typeVehicle }) {
    this.response = response;
    this.data = data;
    this.typeVehicle = typeVehicle;
  }

  get vehicleInfo() {
    const array = [];
    this.response.map(item => {
      const data = {
        label: item.label,
        value: item.value
      };
      array.push(data);
    });
    return array;
  }

  get vehiclePriceRange() {
    const item = this.response;
    let object = {
      brand: '',
      currency_code: '',
      highest_price: 0,
      lowest_price: 0,
      manufacturer: '',
      recommended_price: 0,
      series: '',
      year: 0
    };
    if (item) {
      object = {
        brand: item.brand,
        currency_code: item.currency_code,
        highest_price: item.highest_price,
        lowest_price: item.lowest_price,
        manufacturer: item.manufacturer,
        recommended_price: item.recommended_price,
        series: item.series,
        year: item.year
      };
      return object;
    }
    return object;
  }

  get productList() {
    const array = [];
    this.response.map(item => {
      const data = {
        addons: item.addons,
        admin_fee: item.admin_fee,
        category: item.category,
        currency_code: item.currency_code,
        detail: item.detail,
        hardcopy_admin_fee: item.hardcopy_admin_fee,
        how_to_claim: item.how_to_claim,
        insurance: item.insurance,
        insurance_code: item.insurance_code,
        insurance_detail: item.insurance_detail,
        insurance_product_code: item.insurance_product_code,
        insurer_name: item.insurer_name,
        is_highlighted: item.is_highlighted,
        is_support_commercial: item.is_support_commercial,
        logo: item.logo,
        name: item.name,
        premium: item.premium,
        product_code: item.product_code,
        protection_detail: item.protection_detail,
        summary: item.summary
      };
      array.push(data);
    });
    return array;
  }

  get productDetail() {
    const item = this.response;
    let Obj = {
      addons: [],
      admin_fee: [],
      benefits: '',
      category: {
        code: '',
        description: '',
        name: ''
      },
      currency_code: '',
      detail: {
        claim: {
          flow: [],
          support: {
            available: '',
            call: '',
            email: '',
            whatsapp: ''
          }
        },
        excerpt: [],
        label: [],
        position: '',
        product: {
          benefits: {
            brochure: [],
            feature: [],
            workshop: []
          },
          coverages: [],
          description: '',
          generalInsuranceName: '',
          spesific: [],
          url: {
            brochure: '',
            claim: '',
            tnc: '',
            workshop: ''
          }
        },
        requiredDocuments: [],
        terms: []
      },
      how_to_claim: '',
      insurance: {
        alias: '',
        code: '',
        logo: '',
        name: ''
      },
      insurance_code: '',
      insurance_detail: '',
      insurance_product_code: '',
      insurer_name: '',
      isChecked: '',
      is_highlighted: '',
      is_support_commercial: '',
      logo: '',
      name: '',
      premium: 0,
      product_code: '',
      protection_detail: '',
      summary: ''
    };
    if (item) {
      Obj = {
        addons: item.addons,
        admin_fee: item.admin_fee,
        benefits: item.benefits,
        category: {
          code: item.category.code,
          description: item.category.description,
          name: item.category.name
        },
        currency_code: item.currency_code,
        detail: {
          claim: {
            flow: item.detail.claim.flow,
            support: {
              available: item.detail.claim.support.available,
              call: item.detail.claim.support.call,
              email: item.detail.claim.support.email,
              whatsapp: item.detail.claim.support.whatsapp
            }
          },
          excerpt: item.detail.excerpt,
          label: item.detail.label,
          position: item.detail.position,
          product: {
            benefits: {
              brochure: item.detail.product.benefits.brochure,
              feature: item.detail.product.benefits.feature,
              workshop: item.detail.product.benefits.workshop
            },
            coverages: item.detail.product.coverages,
            description: item.detail.product.description,
            generalInsuranceName: '',
            spesific: item.detail.product.spesific,
            url: {
              brochure: item.detail.product.url.brochure,
              claim: item.detail.product.url.claim,
              tnc: item.detail.product.url.tnc,
              workshop: item.detail.product.url.workshop
            }
          },
          requiredDocuments: item.detail.requiredDocuments,
          terms: item.detail.terms
        },
        how_to_claim: item.how_to_claim,
        insurance: {
          alias: item.insurance.alias,
          code: item.insurance.code,
          logo: item.insurance.logo,
          name: item.insurance.name
        },
        insurance_code: item.insurance_code,
        insurance_detail: item.insurance_detail,
        insurance_product_code: item.insurance_product_code,
        insurer_name: item.insurer_name,
        isChecked: item.isChecked,
        is_highlighted: item.is_highlighted,
        is_support_commercial: item.is_support_commercial,
        logo: item.logo,
        name: item.name,
        premium: item.premium,
        product_code: item.product_code,
        protection_detail: item.protection_detail,
        summary: item.summary
      };
      return Obj;
    }
    return Obj;
  }

  get documentsType() {
    const array = [];
    this.response.map(item => {
      const data = {
        description: item.description,
        extensions: item.extensions,
        name: item.name
      };
      array.push(data);
    });
    return array;
  }

  get documentPresignLink() {
    const item = this.response;
    let object = {
      data: {},
      message: '',
      status: ''
    };
    if (item) {
      object = {
        data: item.data,
        message: item.message,
        status: item.status
      };
      return object;
    }
    return object;
  }

  get policyList() {
    const array = [];
    this.response.map(item => {
      const data = {
        coveredUsers: item.coveredUsers,
        createdAt: item.createdAt,
        customer: item.customer,
        insurance: item.insurance,
        invoice: item.invoice,
        number: item.number,
        policyHolder: item.policyHolder,
        product: item.product,
        status: item.status,
        transaction: item.transaction,
        updatedAt: item.updatedAt,
        vehicle: item.vehicle
      };
      array.push(data);
    });
    return array;
  }

  get policyDetail() {
    const item = this.response;
    let object = {
      coveredUsers: [],
      createdAt: '',
      customer: {
        email: '',
        name: '',
        phoneNumber: ''
      },
      documents: [],
      histories: [],
      insurance: {
        code: '',
        logo: '',
        name: '',
        number: '',
        productCode: '',
        summary: ''
      },
      invoice: {
        amount: 0,
        createdAt: '',
        currency: '',
        data: {
          invoiceId: '',
          status: ''
        },
        expiryDate: '',
        histories: [],
        id: 0,
        invoiceable: '',
        invoiceableId: 0,
        lastStatus: '',
        note: '',
        transactionId: '',
        type: '',
        updatedAt: '',
        url: ''
      },
      number: '',
      policyHolder: {
        ageGroup: '',
        birthPlace: '',
        birthdate: '',
        config: '',
        createdAt: '',
        data: {
          kind: ''
        },
        email: '',
        fullName: '',
        gender: '',
        id: 0,
        idNumber: '',
        idType: '',
        isCovered: null,
        language: '',
        nationality: '',
        occupation: '',
        phoneNumber: '',
        policyId: 0,
        title: '',
        type: '',
        updatedAt: '',
        userId: 0
      },
      product: {
        addons: {
          list: [],
          totalPrice: 0
        },
        adminFee: 0,
        benefit: '',
        benefitCode: '',
        category: '',
        code: '',
        currency: '',
        details: {
          claim: {
            flow: [],
            support: {
              available: '',
              call: '',
              email: ''
            }
          },
          url: {
            brochure: '',
            claim: '',
            tnc: '',
            workshop: ''
          }
        },
        expiredDate: '',
        name: '',
        premi: 0,
        premiPeriod: '',
        premiType: '',
        startedDate: '',
        totalAdminFee: 0,
        totalPremi: 0,
        totalPrice: 0,
        type: ''
      },
      status: '',
      transaction: {
        number: '',
        payment: {
          amount: 0,
          bank: '',
          currency: '',
          method: ''
        }
      },
      type: '',
      updatedAt: '',
      vehicle: {
        accessoriesList: [],
        accessoriesPrice: 0,
        brand: '',
        color: '',
        condition: '',
        currency: '',
        engineNumber: '',
        idNumber: '',
        manufacturer: '',
        plate: '',
        plateNumber: '',
        price: 0,
        region: '',
        series: '',
        totalPrice: 0,
        type: '',
        usageType: '',
        year: 0
      }
    };
    if (item) {
      object = {
        coveredUsers: item.coveredUsers,
        createdAt: item.createdAt,
        customer: {
          email: item.customer.email,
          name: item.customer.name,
          phoneNumber: item.customer.phoneNumber
        },
        documents: item.documents,
        histories: item.histories,
        insurance: {
          code: item.insurance.code,
          logo: item.insurance.logo,
          name: item.insurance.name,
          number: item.insurance.number,
          productCode: item.insurance.productCode,
          summary: item.insurance.summary
        },
        invoice: {
          amount: item.invoice.amount,
          createdAt: item.invoice.createdAt,
          currency: item.invoice.currency,
          data: {
            invoiceId: item.invoice.data.invoiceId,
            status: item.invoice.data.status
          },
          expiryDate: item.invoice.expiryDate,
          histories: item.invoice.histories,
          id: item.invoice.id,
          invoiceable: item.invoice.invoiceable,
          invoiceableId: item.invoice.invoiceableId,
          lastStatus: item.invoice.lastStatus,
          note: item.invoice.note,
          transactionId: item.invoice.transactionId,
          type: item.invoice.type,
          updatedAt: item.invoice.updatedAt,
          url: item.invoice.url
        },
        number: item.number,
        policyHolder: {
          ageGroup: item.policyHolder.ageGroup,
          birthPlace: item.policyHolder.birthPlace,
          birthdate: item.policyHolder.birthdate,
          config: item.policyHolder.config,
          createdAt: item.policyHolder.createdAt,
          data: {
            kind: item.policyHolder.kind
          },
          email: item.policyHolder.email,
          fullName: item.policyHolder.fullName,
          gender: item.policyHolder.gender,
          id: item.policyHolder.id,
          idNumber: item.policyHolder.idNumber,
          idType: item.policyHolder.idType,
          isCovered: item.policyHolder.isCovered,
          language: item.policyHolder.language,
          nationality: item.policyHolder.nationality,
          occupation: item.policyHolder.occupation,
          phoneNumber: item.policyHolder.phoneNumber,
          policyId: item.policyHolder.policyId,
          title: item.policyHolder.title,
          type: item.policyHolder.type,
          updatedAt: item.policyHolder.updatedAt,
          userId: item.policyHolder.userId
        },
        product: {
          addons: {
            list: item.product.addons.list,
            totalPrice: item.product.addons.totalPrice
          },
          adminFee: item.product.adminFee,
          benefit: item.product.benefit,
          benefitCode: item.product.benefitCode,
          category: item.product.category,
          code: item.product.code,
          currency: item.product.currency,
          details: {
            claim: {
              flow: item.product.details.claim.flow,
              support: {
                available: item.product.details.claim.support.available,
                call: item.product.details.claim.support.call,
                email: item.product.details.claim.support.email
              }
            },
            url: {
              brochure: item.product.details.url.brochure,
              claim: item.product.details.url.claim,
              tnc: item.product.details.url.tnc,
              workshop: item.product.details.url.workshop
            }
          },
          expiredDate: item.product.expiredDate,
          name: item.product.name,
          premi: item.product.premi,
          premiPeriod: item.product.premiPeriod,
          premiType: item.product.premiType,
          startedDate: item.product.startedDate,
          totalAdminFee: item.product.totalAdminFee,
          totalPremi: item.product.totalPremi,
          totalPrice: item.product.totalPrice,
          type: item.product.type
        },
        status: item.status,
        transaction: {
          number: item.transaction.number,
          payment: {
            amount: item.transaction.payment.amount,
            bank: item.transaction.payment.bank,
            currency: item.transaction.payment.currency,
            method: item.transaction.payment.method
          }
        },
        type: item.type,
        updatedAt: item.updatedAt,
        vehicle: {
          accessoriesList: item.vehicle.accessoriesList,
          accessoriesPrice: item.vehicle.accessoriesPrice,
          brand: item.vehicle.brand,
          color: item.vehicle.color,
          condition: item.vehicle.condition,
          currency: item.vehicle.currency,
          engineNumber: item.vehicle.engineNumber,
          idNumber: item.vehicle.idNumber,
          manufacturer: item.vehicle.manufacturer,
          plate: item.vehicle.plate,
          plateNumber: item.vehicle.plateNumber,
          price: item.vehicle.price,
          region: item.vehicle.region,
          series: item.vehicle.series,
          totalPrice: item.vehicle.totalPrice,
          type: item.vehicle.type,
          usageType: item.vehicle.usageType,
          year: item.vehicle.year
        }
      };
      return object;
    }
    return object;
  }

  get prequoteData() {
    let Obj = {
      plate: '',
      type: '',
      manufacturer: '',
      brand: '',
      series: '',
      year: '',
      price: 0,
      accessoriesPrice: 0,
      condition: '',
      usageType: '',
      insuranceType: '',
      insuranceStart: '',
      insuranceEnd: ''
    };
    if (Object.keys(this.data).length > 0) {
      const { accessories } = this.data;
      let vehicleInfo;
      if (this.typeVehicle === 'CAR') {
        vehicleInfo = this.data.carInfo;
      } else {
        vehicleInfo = this.data.motorInfo;
      }
      Obj = {
        plate: vehicleInfo.plate,
        type: this.typeVehicle,
        manufacturer: vehicleInfo.brand,
        brand: vehicleInfo.model,
        series: vehicleInfo.series,
        year: this.typeVehicle === 'CAR' ? vehicleInfo.carYear : vehicleInfo.motorYear,
        price: vehicleInfo.price.recommended_price ? vehicleInfo.price.recommended_price.replace(/\./g, '') : '',
        accessoriesPrice: accessories ? helper().currenciesToNumber(accessories.price.recommended_price) : 0,
        condition: 'USED',
        usageType: 'PERSONAL',
        insuranceType: vehicleInfo.protectionType,
        insuranceStart: '2019-01-01T00:00:00+00:00',
        insuranceEnd: '2020-01-01T00:00:00+00:00'
      };
      return Obj;
    }
    return Obj;
  }
}

export const mapResponse = ({ type, response }) => {
  const transformResponse = new Transform({ response });
  return transformResponse[type];
};

export const mapPayload = ({ type, data, typeVehicle }) => {
  const transformPayload = new Transform({ data, typeVehicle });
  return transformPayload[type];
};
